import { render, staticRenderFns } from "./_SwitchSupplierTypeDialog.vue?vue&type=template&id=3a96851c"
import script from "./_SwitchSupplierTypeDialog.vue?vue&type=script&lang=js"
export * from "./_SwitchSupplierTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports